/**
 * Car Configuration Handler - Direct Approach
 * Intercepts Add to Cart button and adds properties directly via Shopify API
 */

(function () {
  // Parse vehicle config from URL hash
  function parseVehicleConfig() {
    const hash = window.location.hash.slice(1);

    if (!hash) {
      return null;
    }

    const parts = hash.split('/');
    if (parts.length < 1) return null;

    // Decode function - handles both new format (__ for spaces) and legacy format
    function decode(str) {
      if (!str) return '';
      let result = str;
      try {
        result = decodeURIComponent(result);
      } catch (e) {}

      // Check if using new format (contains __)
      if (result.includes('__')) {
        // New format: __ = space, -- = comma-space
        result = result.replace(/\(~~\)/g, '(--)');
        result = result.replace(/--/g, ', ');
        result = result.replace(/__/g, ' ');
      } else {
        // Legacy format
        result = result.replace(/\(~~\)/g, '(--)');
        result = result.replace(/\(--\)/g, '(--)');
        result = result.replace(/--/g, ', ').replace(/-/g, ' ');
      }

      result = result.replace(/(\d+)(ccm|KW|PS|kW|hp|ps)/g, '$1 $2');
      return result;
    }

    const manufacturer = decode(parts[0]);
    const model = parts[1] ? decode(parts[1]) : '';
    const motor = parts[2] ? decode(parts[2]) : '';

    if (!manufacturer) return null;

    return { manufacturer, model, motor };
  }

  // Custom add to cart with properties
  function addToCartWithConfig(formData, vehicleConfig) {
    // Add vehicle properties to formData
    formData.set('properties[Hersteller]', vehicleConfig.manufacturer);
    formData.set('properties[Modell]', vehicleConfig.model);
    formData.set('properties[Motor]', vehicleConfig.motor);

    let fullConfig = vehicleConfig.manufacturer;
    if (vehicleConfig.model) fullConfig += ` / ${vehicleConfig.model}`;
    if (vehicleConfig.motor) fullConfig += ` / ${vehicleConfig.motor}`;
    formData.set('properties[Fahrzeugkonfiguration]', fullConfig);

    // Send to Shopify
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // Also save to cart attributes for packing slip
        const attributeData = {
          attributes: {
            Fahrzeugkonfiguration: fullConfig,
          },
        };

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(attributeData),
        }).then(() => data);
      });
  }

  // Update hidden inputs for form fallback
  function updateHiddenInputs(vehicleConfig) {
    const fullConfigInput = document.getElementById('car-config-full');
    const manufacturerInput = document.getElementById('car-config-manufacturer');
    const modelInput = document.getElementById('car-config-model');
    const motorInput = document.getElementById('car-config-motor');

    console.log('🚗 updateHiddenInputs called:', {
      vehicleConfig,
      foundInputs: {
        full: !!fullConfigInput,
        manufacturer: !!manufacturerInput,
        model: !!modelInput,
        motor: !!motorInput,
      },
    });

    if (vehicleConfig) {
      let fullConfig = vehicleConfig.manufacturer;
      if (vehicleConfig.model) fullConfig += ` / ${vehicleConfig.model}`;
      if (vehicleConfig.motor) fullConfig += ` / ${vehicleConfig.motor}`;

      if (fullConfigInput) fullConfigInput.value = fullConfig;
      if (manufacturerInput) manufacturerInput.value = vehicleConfig.manufacturer;
      if (modelInput) modelInput.value = vehicleConfig.model;
      if (motorInput) motorInput.value = vehicleConfig.motor;

      console.log('🚗 Hidden inputs updated:', {
        fullConfig,
        manufacturer: vehicleConfig.manufacturer,
        model: vehicleConfig.model,
        motor: vehicleConfig.motor,
      });
    } else {
      if (fullConfigInput) fullConfigInput.value = '';
      if (manufacturerInput) manufacturerInput.value = '';
      if (modelInput) modelInput.value = '';
      if (motorInput) motorInput.value = '';
      console.log('🚗 Hidden inputs cleared (no vehicle config)');
    }
  }

  // Initialize - wait for DOM and intercept forms
  function init() {
    const vehicleConfig = parseVehicleConfig();

    // Always update hidden inputs (even if no config, to clear them)
    updateHiddenInputs(vehicleConfig);

    if (!vehicleConfig) {
      return;
    }

    // Try multiple ways to find the form
    let form = null;

    // Method 1: Try product-form custom element
    const productForm = document.querySelector('product-form');
    if (productForm) {
      form = productForm.querySelector('form');
    }

    // Method 2: Try form with action="/cart/add"
    if (!form) {
      form = document.querySelector('form[action*="/cart/add"]');
    }

    // Method 3: Try any form with id or name containing "product"
    if (!form) {
      form = document.querySelector('form[id*="product"], form[name*="product"]');
    }

    // Method 4: Try form with button containing "warenkorb"
    if (!form) {
      const button = document.querySelector('button[type="submit"]');
      if (button) {
        form = button.closest('form');
      }
    }

    if (!form) {
      console.warn('⚠️ Could not find product form, trying again in 1 second...');
      setTimeout(init, 1000);
      return;
    }

    // Find the submit button - try multiple ways
    let submitButton = form.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');

    // If not found in form, search globally
    if (!submitButton) {
      // Try to find button by text content
      const buttons = document.querySelectorAll('button, input[type="submit"]');
      for (const btn of buttons) {
        const text = btn.textContent?.toLowerCase() || btn.value?.toLowerCase() || '';
        if (text.includes('warenkorb') || text.includes('add to cart') || text.includes('in den')) {
          submitButton = btn;
          break;
        }
      }
    }

    if (!submitButton) {
      console.warn('⚠️ Submit button not found anywhere, trying again in 1 second...');
      setTimeout(init, 1000);
      return;
    }

    // Intercept button click BEFORE anything else
    submitButton.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Get the form (might be different from the one we found earlier)
        const actualForm = submitButton.closest('form') || form;

        // Get form data
        const formData = new FormData(actualForm);

        // Add to cart with vehicle config
        addToCartWithConfig(formData, vehicleConfig)
          .then(() => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('❌ Error adding to cart:', error);
            alert('Fehler beim Hinzufügen zum Warenkorb');
          });

        return false;
      },
      true
    ); // Capture phase - runs FIRST!
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run on hash change
  window.addEventListener('hashchange', init);

  // Listen for car configuration changes from React (replaceState doesn't trigger hashchange)
  window.addEventListener('carConfigurationChanged', (event) => {
    console.log('🚗 carConfigurationChanged event received:', event.detail);
    init();
  });
})();
